module.exports = __webpack_public_path__ + "static/media/all.d871c80d.svg";